// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".service-name[data-v-e432bf52],\n.manage-text[data-v-e432bf52] {\n  color: #2d9cdb;\n}\n.opened[data-v-e432bf52] {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.entity-subtitle[data-v-e432bf52] {\n  font-size: 9px;\n  color: #A6A4A6;\n}", ""]);
// Exports
module.exports = exports;
